import Api from '../../../services/Api'

export function updateDefaultColumnsTableSorting(data: any) {
  const url = `/products/inquiries/columns`

  return Api.get(url, data).then((d: any) => {
    return d
  })
}

export function getAllDefaultColumns(filters: any) {
  const url = `/products/inquiries/columns/listing`
  return Api.get(url, filters).then((d: any) => {
    return d.data
  })
}
